export default function ConfirmedSubscription() {
  return <div>Thanks for getting bond.MAX!</div>;
}
